import Switch from '@components/v2/form/Switch/Switch';
import { Box } from '@mui/material';
import LangEnum from '../../../../lang/LangEnum';
import { GeneralSettingsParams } from '../../../../stores/GeneralSettings/generalSettings.types';
import { useTranslation } from '../../../translation/TranslationContext';
import SettingContainer from '../../SettingContainer';
import { CatalogsSectionGeneralSettingsProps } from '../types/GeneralSettings.types';

const CatalogsSectionGeneralSettings = ({
  generalSettings,
  handleChangeAndBlur,
}: CatalogsSectionGeneralSettingsProps) => {
  const { translate } = useTranslation();

  return (
    <SettingContainer
      title={translate(LangEnum.GLOBAL_CATALOGS)}
      description={LangEnum.BRAND_SETTINGS_CATALOG_SHOW_SELL_IN_PRICE_FILTER}
    >
      <Box display="flex" flexDirection="column" gap={3}>
        <Switch
          label={translate(LangEnum.BRAND_SETTINGS_CATALOG_SHOW_SELL_IN_PRICE_FILTER)}
          name="showSellInPriceFilterInCatalogs"
          size="medium"
          checked={generalSettings.showSellInPriceFilterInCatalogs}
          onChange={(event, checked) =>
            handleChangeAndBlur({
              value: checked,
              name: event.target.name as keyof GeneralSettingsParams,
            })
          }
        />
      </Box>
    </SettingContainer>
  );
};

export default CatalogsSectionGeneralSettings;
